var e = /* @__PURE__ */ ((r) => (r.erc20 = "ERC20", r.erc721 = "ERC721", r.erc1155 = "ERC1155", r))(e || {});
export {
  e as ErcType
};
//# sourceMappingURL=erc.js.map
